import { HttpErrorResponse } from '@angular/common/http';

export class ErrorModalData {
    constructor(public action: string = '',
                public text: string = '',
                public httpError: HttpErrorResponse = null) {
    }
}
